//mandatory
export var DrawerVariantPositionTypes;
(function (DrawerVariantPositionTypes) {
    DrawerVariantPositionTypes["DRAWER_LEFT"] = "DRAWER_LEFT";
    DrawerVariantPositionTypes["DRAWER_RIGHT"] = "DRAWER_RIGHT";
    DrawerVariantPositionTypes["DRAWER_BOTTOM"] = "DRAWER_BOTTOM";
    DrawerVariantPositionTypes["DRAWER_NO_ANIMATION"] = "DRAWER_NO_ANIMATION";
})(DrawerVariantPositionTypes || (DrawerVariantPositionTypes = {}));
//# sourceMappingURL=variantPosition.js.map